import './LoadingScreen.css'

/**
 * LoadingScreen — ecran de chargement plein conteneur.
 *
 * Utilise pour les transitions d'authentification (auth context en cours
 * de resolution, redirection en attente). Reutilise par ProtectedRoute,
 * LoginPage, et tout futur ecran qui doit afficher un etat de chargement
 * pleine page sans navigation deja montee.
 *
 *   <LoadingScreen />
 *   <LoadingScreen label="Verification de la session…" />
 */

interface LoadingScreenProps {
  label?: string
}

export default function LoadingScreen({ label = 'Chargement…' }: LoadingScreenProps) {
  return (
    <div className="loading-screen ui-text-muted" role="status" aria-live="polite">
      {label}
    </div>
  )
}
